import React from "react";
import Image from "@gc-npm/components.c-image";
import TextInfo from "@gc-npm/components.text";

const COMPONENT_NAME = "IMAGE_STEPS_CARD";

const DescriptionCard = (props) => {
  const isWebView = process.env.NEXT_PUBLIC_WEB_VIEW === "true";
  return (
    <>
      <div className="image-steps-card-container container" data-cy="Image Steps Card">
        {props.Layout === "left" && (
          <div className={`image-container--${props?.Layout && props?.Layout}`}>
            {props["Image-1"] && props["Image-1"].src && (
              <Image {...props["Image-1"]} cyData="Image Steps Card Image" />
            )}
          </div>
        )}
        <div className="content-container">
          <div className="card-header" data-cy="Image Steps Card Header">
            {props["Text-1"] && props["Text-1"].text && (
              <TextInfo {...props["Text-1"]} cyData="Image Steps Card Title" />
            )}

            {props["Text-2"] && props["Text-2"].text && (
              <TextInfo {...props["Text-2"]} cyData="Image Steps Card SubTitle" />
            )}
          </div>

          <div className="card-body">
            {props["Text-3"] && props["Text-3"].text && (
              <TextInfo {...props["Text-3"]} cyData="Image Steps Card Paragraph" />
            )}
          </div>
        </div>
        {props.Layout !== "left" && (
          <div className={`image-container--${props?.Layout && props?.Layout}`}>
            {props["Image-1"] && props["Image-1"].src && (
              <Image {...props["Image-1"]} cyData="Image Steps Card Image" />
            )}
          </div>
        )}
      </div>
      <style jsx>{`
        .image-steps-card-container {
          border: 0px solid rgb(221, 221, 221);
          min-height: 100px;
          border-radius: 1rem;
          display: block;
          grid-template-columns: 1fr;
          grid-template-rows: 1fr 1fr;
          gap: 1rem;
          overflow: hidden;
          margin-bottom: 0.5rem;
          & :global(*) {
            line-height: 1.5rem;
          }

          .content-container {
            padding: 1rem 0;
            flex: 1;

            .card-header {
              margin-bottom: 1rem;

              & > :global(*) {
                margin-bottom: 4px;
              }
            }

            .card-body {
              & > :global(*) {
                line-height: 120%;
              }

              :global(.next-link) {
                justify-content: flex-start;
                padding: 0;
                padding-top: 1rem;
                margin-bottom: 1rem;
              }
            }
          }

          .image-container {
            grid-row: 1;
            position: relative;
            overflow: hidden;
            &--left {
              grid-row: 1 !important;

              :global(img) {
                width: 100%;
                border-radius: 16px;
              }
            }
            &--right {
              :global(img) {
                width: 100%;
                border-radius: 16px;
              }
            }
          }
        }

        @media screen and (min-width: 768px) {
          .image-steps-card-container {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr;
            display: flex;
            .content-container {
            }

            .image-container {
              grid-row: 0;
              grid-column: 2;

              &--left {
                width: 50%;
              }
              &--right {
                width: 50%;
              }
            }
            :global(div:empty) {
              display: none;
            }
          }
        }
      `}</style>
    </>
  );
};

export default DescriptionCard;
